import $ from "jquery";

(function ($, window, document) {
  "use strict";

  // Main Menu
  var TLS_Generator_cf = function () {
    var self = this;
    var comuni = null;

    this.select_init = function(){
      // Get the modal
      var modal = document.getElementById("cfgenModal");

      // Get the button that opens the modal
      var btn = document.getElementById("cfOpenBtn");

      // Get the <span> element that closes the modal
      var span = document.getElementsByClassName("closeCfModal")[0];
      
      

      // When the user clicks on the button, open the modal
      if(btn){
      btn.onclick = function () {
        modal.style.display = "block";
      };
      }

      // When the user clicks on <span> (x), close the modal
      if (span) { 
        span.onclick = function () {
          modal.style.display = "none";
        };
      }

      // When the user clicks anywhere outside of the modal, close it
      window.onclick = function (event) {
        if (event.target == modal) {
          modal.style.display = "none";
        }
      };

      if($(".select2-comune").length){
        self.loadComuni();
      }

      // if ($("#billing_city").length) {
      //   self.loadComuni();
      // }
      // if ($("#shipping_city").length) {
      //   self.loadComuni();
      // }
      
    };

    this.loadComuni = async function() {
      const response = await fetch("/wp-content/themes/longevitysuite/src/assets/comuni.json");
      const names = await response.json();

      if($(".select2-comune").length){
        let comuni = names.map((a) => ({id: a.codiceCatastale, text: a.nome}));
        $(".select2-comune").select2({
          data: comuni,
        });
      }

      // if ($("#billing_city").length) {
      //   let comuni = names.map((a) => ({ id: a.nome, text: a.nome }));
      //   $("#billing_city").select2({
      //     width: "100%",
      //     allowClear: true,
      //     maximumSelectionSize: 1,
      //     placeholder: "Start typing",
      //     data: comuni,
      //   });
      // }

      // if ($("#shipping_city").length) {
      //   let comuni = names.map((a) => ({ id: a.nome, text: a.nome }));
      //   $("#shipping_city").select2({
      //     width: "100%",
      //     allowClear: true,
      //     maximumSelectionSize: 1,
      //     placeholder: "Start typing",
      //     data: comuni,
      //   });
      // }


    };

    this.sendForm = function(e){
      console.log($(this));
      
          e.preventDefault(); // avoid to execute the actual submit of the form.

            var $thisbutton = $(this),
              $form = $thisbutton.closest("form.cfFormGenerator"),
              name = $form.find("input[name=cf_first_name]").val(),
              surname = $form.find("input[name=cf_last_name]").val(),
              sesso = $form.find("select[name=cf_sesso] option").filter(':selected').val(),
              birthdate = $form.find("input[name=cf_birthdate]").val(),
              comune = $form.find("select[name=cf_comune] option:selected").filter(':selected').val(),
              data = {
                action: "tls_gen_cf_code",
                name: name,
                surname: surname,
                sesso: sesso,
                birthdate: birthdate,
                comune: comune,
              };

        $.ajax({
          type: "post",
          url: wc_checkout_params.ajax_url,
          data: data,
          beforeSend: function (response) {
            $("#cfResult").addClass("loading");
          },
          complete: function (response) {
            $("#cfResult").removeClass("loading");
          },
          success: function (response) {
            if (response.error) {
              $("#cfResult").removeClass("loading");
            } else {
              $("#cfResult").html(response.cf);
            }
          },
        });
    };

    this.useCFGenerate = function(){
        var cf = $('#cfResult').text();
        if(cf){
            $("#billing_codice_fiscale").val(cf);
            var modal = document.getElementById("cfgenModal");
            modal.style.display = "none";
        }
    };

    this.bind = function () {
        $(document).on("ready", self.select_init);
        $(document).on("click", "#btGenCF", self.sendForm);
        $(document).on("click", "#useCFGenerate", self.useCFGenerate);
    };

    this.init = function () {
      self.bind();
    };

    this.init();
  };

  new TLS_Generator_cf();
})(window.jQuery, window, document);